// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2OKBx","content":"styles_content__3oKZc","checkbox":"styles_checkbox__3XD6z","checkboxLabel":"styles_checkboxLabel__340_s"};